<template>
  <div>
    <div class="accesscontrol-role-main-container">
      <div class="p-3 h-100">
        <div class="d-flex align-items-center justify-content-between">
          <div
            @click="closeScheduleInterview"
            class="position-absolute pointer accesscontrol-backArrow"
          >
            <img src="../../../assets/img/accessconnew/boxBackArrow.svg" alt />
          </div>
          <div class="addrole-heading ml-3 pt-1">
            <span> {{ schedulename }} </span>
          </div>
          <div class="d-flex align-items-center">
            <div
              v-if="toRound != 'F' && schedulename == 'Schedule Interview'"
              class="mr-3 pointer"
              @click="$emit('show-alreadyinterviewed')"
            >
              <img
                class="mr-2 mb-1"
                src="../../../assets/img/already-interviewed.svg"
                alt=""
              />
              <span class="mt-1 already-font">Already Interviewed ?</span>
            </div>
            <div
              v-if="toRound != 'F' && schedulename == 'Schedule Interview'"
              class="mr-3"
            >
              <img src="../../../assets/img/line.svg" alt="" />
            </div>
            <div
              @click="closeScheduleInterview()"
              class="rotate-on-hover pointer"
            >
              <img
                v-b-tooltip.hover.top="'Close'"
                src="../../../assets/img/accessconnew/blueCross.svg"
                alt
              />
            </div>
          </div>
        </div>
        <hr class="mb-0" />
        <div class="mt-1 common-blue-card">
          <b-card>
            <b-row class="align-items-center">
              <b-col cols="5">
                <div class="d-flex align-items-center">
                  <div class="common-sm-profile-icon mr-2">
                    <div
                      class="mr-2"
                      :class="
                        candidate.customFields &&
                        candidate.customFields.imageMedia &&
                        candidate.customFields.imageMedia != null
                          ? 'common-sm-profile-transparet-icon'
                          : 'common-sm-profile-icon'
                      "
                    >
                      <b-avatar
                        v-if="
                          candidate.customFields &&
                          candidate.customFields.imageMedia &&
                          candidate.customFields.imageMedia != null
                        "
                        :src="candidate.customFields.imageMedia"
                      ></b-avatar>
                      <b-avatar
                        v-else
                        :text="candidate.name[0].toUpperCase()"
                      ></b-avatar>
                    </div>
                  </div>
                  <div class="common-blue-card-head text-truncate">
                    {{ candidate.name }}
                  </div>
                </div>
              </b-col>
              <b-col cols="7">
                <div
                  class="
                    common-blue-card-subhead
                    d-flex
                    align-items-center
                    justify-content-end
                  "
                >
                  <div
                    class="
                      mr-3
                      d-flex
                      w-100
                      align-items-center
                      justify-content-end
                    "
                  >
                    <img
                      class="mr-1"
                      src="@/assets/new-kanban-icons/mail.svg"
                      alt=""
                    />

                    <div class="text-truncate">{{ candidate.email }}</div>
                  </div>
                  <div class="mr-3">
                    <img src="@/assets/new-kanban-icons/Line.svg" alt="" />
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="mr-1">
                      <img src="@/assets/new-kanban-icons/phone.svg" alt="" />
                    </div>
                    <div>{{ candidate.phoneNumber }}</div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </div>
        <div class="overflow-xy pr-2" style="height: calc(100vh - 275px)">
          <b-row>
            <b-col>
              <div class="mt-2">
                <DateField
                  :from="'kanban'"
                  :type="'date'"
                  :label="'Date'"
                  :mandatory="true"
                  :placeholder="'Select Date'"
                  :format="'DD-MM-YYYY'"
                  :id="'to-and-from'"
                  :vmodel="ScheduleInterview.selDate"
                  @select-value="ScheduleInterview.selDate = $event"
                  :showError="
                    isStartDateValid || $v.ScheduleInterview.selDate.$error
                  "
                />
              </div>
              <!-- <div class="mt-2">
                <div class="schedint-label-heads">Date</div>
                <div class="position-relative newmodalinputbox mt-1">
                  <b-form-input placeholder="Enter Email"> </b-form-input>
                </div>
              </div> -->
            </b-col>
            <b-col>
              <!-- in date field component instead of topdiv wen its kanban bind this class newmodalinputbox -->
              <div class="mt-2">
                <DateField
                  :from="'kanban'"
                  :icon="'time'"
                  :type="'date'"
                  :id="'dis-startTime'"
                  :label="'Start Time'"
                  :mandatory="true"
                  :disabled="!ScheduleInterview.selDate"
                  :placeholder="'Select Start Time'"
                  :format="'HH:mm'"
                  :vmodel="ScheduleInterview.startTime"
                  :disableTime="disableTime"
                  @select-value="ScheduleInterview.startTime = $event"
                  :showError="
                    $v.ScheduleInterview.startTime.$error || inValidStartTime
                  "
                />
                <!-- <div class="schedint-label-heads">Start Time</div>
                <div class="position-relative newmodalinputbox mt-1">
                  <b-form-input placeholder="Enter Email"> </b-form-input>
                </div> -->
              </div>
            </b-col>
            <b-col>
              <div class="mt-2">
                <DateField
                  :from="'kanban'"
                  :type="'date'"
                  :icon="'time'"
                  :id="'dis-endTime'"
                  :label="'End Time'"
                  :mandatory="true"
                  :disabled="
                    !ScheduleInterview.selDate || !ScheduleInterview.startTime
                  "
                  :placeholder="'Select End Time'"
                  :format="'HH:mm'"
                  :disableTime="disableTime"
                  :vmodel="ScheduleInterview.endTime"
                  :startTime="ScheduleInterview.startTime"
                  @select-value="ScheduleInterview.endTime = $event"
                  :showError="
                    $v.ScheduleInterview.endTime.$error || inValidEndTime
                  "
                />
              </div>
            </b-col>
          </b-row>
          <template>
            <div class="d-flex schedint-main-heads justify-content-between">
              <h6 class="fw-600 fs-16 font-lato color-black mt-3">
                Allocate Panelist<span class="asterik">*</span>
              </h6>
              <span v-if="panelError" class="errortext mt-3">
                <img
                  src="../../../assets/img/newkanban/info-circle.svg"
                  class="mr-1"
                  alt=""
                />
                {{ panelErrorText }}
              </span>
            </div>
            <template
              v-if="
                !vendor &&
                !showinternalexternalContent &&
                !showhire3xPanelContent &&
                !showbotinterviewContent
              "
            >
              <section
                class="
                  w-100
                  d-flex
                  align-items-center
                  justify-content-between
                  gap-15
                  mt-1
                "
              >
                <div
                  :class="
                    (!ScheduleInterview.selDate ||
                      !ScheduleInterview.startTime ||
                      !ScheduleInterview.endTime) &&
                    'disabled-kanban-img'
                  "
                  class="
                    si-allocate-cards
                    d-flex
                    flex-column
                    justify-content-center
                    align-items-center
                    pointer
                  "
                  @click="
                    ScheduleInterview.selDate &&
                    ScheduleInterview.startTime &&
                    ScheduleInterview.endTime
                      ? (showinternalexternalContent = true)
                      : ''
                  "
                >
                  <img
                    src="../../../assets/img/scheduleinterview/intexternal.svg"
                    alt=""
                  />
                  <h5 class="fw-600 fs-16 color-darkblack font-mont mt-3">
                    {{
                      !checkVendorExt
                        ? "Internal"
                        : !checkVendorInt
                        ? "External"
                        : "Internal/External"
                    }}
                  </h5>
                  <p class="fw-400 fs-14 color-717171 font-lato text-center">
                    Schedule with a panelist{{
                      !checkVendorExt
                        ? " within"
                        : !checkVendorInt
                        ? " outside"
                        : " within or outside"
                    }}
                    the organization.
                  </p>
                </div>
                <div
                  v-if="toRound != 'F'"
                  :class="
                    (disableHire3xPanel ||
                      !ScheduleInterview.selDate ||
                      !ScheduleInterview.startTime ||
                      !ScheduleInterview.endTime) &&
                    'disabled-kanban-img'
                  "
                  class="
                    si-allocate-cards
                    d-flex
                    flex-column
                    justify-content-center
                    align-items-center
                    pointer
                  "
                  @click="
                    !disableHire3xPanel &&
                    ScheduleInterview.selDate &&
                    ScheduleInterview.startTime &&
                    ScheduleInterview.endTime
                      ? ((showhire3xPanelContent = true), getHire3xPanelCount())
                      : ''
                  "
                >
                  <img
                    src="../../../assets/img/scheduleinterview/hire3x.svg"
                    alt=""
                  />
                  <h5 class="fw-600 fs-16 color-darkblack font-mont mt-3">
                    Hire3x Panel
                  </h5>
                  <p
                    class="fw-400 fs-14 color-717171 font-lato mt-2 text-center"
                    v-html="scheduleText"
                  ></p>
                </div>
                <div
                  :class="
                    (!ScheduleInterview.selDate ||
                      !ScheduleInterview.startTime ||
                      !ScheduleInterview.endTime) &&
                    'disabled-kanban-img'
                  "
                  v-if="checkVCCLAccess && showBot"
                  class="
                    si-allocate-cards
                    d-flex
                    flex-column
                    justify-content-center
                    align-items-center
                    pointer
                  "
                  @click="
                    ScheduleInterview.selDate &&
                    ScheduleInterview.startTime &&
                    ScheduleInterview.endTime
                      ? (showbotinterviewContent = true)
                      : ''
                  "
                >
                  <img
                    src="../../../assets/img/scheduleinterview/botinterview.svg"
                    alt=""
                  />
                  <h5 class="fw-600 fs-16 color-darkblack font-mont mt-3">
                    Bot Interview
                  </h5>
                  <p class="fw-400 fs-14 color-717171 font-lato text-center">
                    Conduct an automated AI-driven interview.
                  </p>
                </div>
              </section>
            </template>
            <template
              v-if="
                showinternalexternalContent ||
                vendor ||
                (!vendor && !checkVCCLAccess)
              "
            >
              <section class="si-allocate-cards h-auto mt-3">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="fw-500 fs-16 font-lato color-black">
                    <img
                      v-if="checkVCCLAccess && !vendor && showBot"
                      src="../../../assets/img/scheduleinterview/bckarw.svg"
                      alt=""
                      class="mr-1 pointer"
                      @click="showinternalexternalContent = false"
                    />
                    Allocate{{
                      !checkVendorExt
                        ? " Internal"
                        : !checkVendorInt
                        ? " External"
                        : " Internal/External"
                    }}
                    Panelist(s):<span class="asterik">*</span>
                  </div>
                  <div
                    v-if="checkVendorInt"
                    :class="panelDisabled && 'disabled-kanban-img'"
                    @click="!panelDisabled ? (showPanel = true) : ''"
                    class="font-lato fw-600 fs-14 color-mainblue pointer"
                  >
                    <img
                      src="../../../assets/img/scheduleinterview/view.svg"
                      class="mr-2"
                      alt=""
                    />
                    View Internal Panelist
                  </div>
                </div>
                <hr style="border-top: 1px dashed #d0d5dd" />
                <div class="d-flex align-items-center w-100 mb-3 gap-15">
                  <label class="fs-14 fw-500 color-3a3c40 font-lato"
                    >Tag Panelist :</label
                  >
                  <div
                    class="position-relative newmodalinputbox ml-3"
                    :class="checkVendorExt ? 'w-70' : 'w-85'"
                  >
                    <b-form-input
                      :placeholder="searchPlaceholder"
                      :class="{
                        error: emailError || emailAdded,
                      }"
                      :disabled="panelDisabled"
                      v-model.trim="extEmail"
                      :debounce="400"
                      :formatter="(val) => val.toLowerCase()"
                      @keyup.enter="
                        checkVendorExt &&
                        !emailAdded &&
                        isValidEmail &&
                        extEmail &&
                        !panelDisabled
                          ? addPanel(extEmail)
                          : ''
                      "
                      v-closable="{
                        exclude: ['searchdrop'],
                        handler: 'closeSearch',
                      }"
                    >
                    </b-form-input>
                    <!-- @scroll="panelList.length == 0 ? onScroll($event) : ''" -->

                    <div
                      class="si-search-dd w-100"
                      ref="searchdrop"
                      v-if="
                        showsearchDropdown &&
                        panelDetails.length != 0 &&
                        checkVendorInt
                      "
                    >
                      <div
                        class="
                          si-search-dd-option
                          d-flex
                          align-items-center
                          justify-content-between
                          pointer
                        "
                        @click="addPanel(panel)"
                        v-for="panel in panelDetails"
                        :key="panel.panelID"
                      >
                        <div class="d-flex align-items-center w-100">
                          <b-avatar
                            variant="primary"
                            :text="panel.name[0]"
                            class="mr-3 si-search-dd-option-dp w-20"
                          ></b-avatar>
                          <div style="margin-top: 10px" class="w-80">
                            <h5
                              class="
                                fw-400
                                font-lato
                                fs-14
                                color-mainblue
                                mb-0
                                text-truncate
                              "
                            >
                              {{ panel.name }}
                            </h5>
                            <h6
                              class="
                                color-7ba1c2
                                fw-400
                                font-lato
                                fs-13
                                text-truncate
                              "
                            >
                              {{ panel.email }}
                            </h6>
                          </div>
                        </div>
                        <!-- for available bind color-green -->
                        <!-- <div class="fw-400 fs-12 font-lato color-brightred">
                        Out of Organization
                      </div> -->
                      </div>
                      <div
                        style="margin: auto"
                        v-if="showLoader"
                        class="d-flex justify-content-center mt-2"
                      >
                        <b-spinner label="Loading..."></b-spinner>
                      </div>
                    </div>

                    <div
                      v-if="emailError || emailAdded"
                      class="
                        font-lato
                        fw-400
                        fs-12
                        color-brightred
                        position-absolute
                        d-flex
                      "
                    >
                      <img
                        src="../../../assets/img/scheduleinterview/validation.svg"
                        alt=""
                      />
                      <span v-if="emailAdded"> Email is already added. </span>
                      <span v-else>
                        Email
                        {{
                          !checkVendorExt
                            ? "does not exist."
                            : !checkVendorInt
                            ? "is invalid."
                            : "does not exist/invalid."
                        }}
                      </span>
                    </div>
                    <div
                      v-else-if="checkVendorExt"
                      class="
                        font-lato
                        fw-400
                        fs-12
                        color-7a7a7a
                        position-absolute
                      "
                    >
                      Press Enter Key to add the email ID
                    </div>
                  </div>
                  <div class="bluebtn">
                    <b-button
                      v-if="checkVendorExt"
                      @click="
                        isValidEmail && extEmail && !panelDisabled
                          ? addPanel(extEmail)
                          : ''
                      "
                      :disabled="!isValidEmail || !extEmail || panelDisabled"
                      class="acs-addBtn-modal w-110 ml-2"
                      >Tag</b-button
                    >
                  </div>
                </div>
                <section v-if="totalPanel.length" class="mt-4">
                  <div
                    class="
                      color-3a3c40
                      fw-500
                      font-lato
                      fs-16
                      d-flex
                      align-items-center
                    "
                  >
                    Selected Panelist:
                    <span class="fw-700 fs-18 color-mainblue"
                      >&nbsp;{{ totalPanel.length }}</span
                    >
                  </div>
                  <section
                    class="d-flex align-items-center flex-wrap gap-15 mt-2"
                    style="overflow-y: auto"
                  >
                    <div
                      class="si-panelist-tags d-flex align-items-center"
                      v-for="(selpan, index) in totalPanel"
                      :key="selpan.name + index"
                    >
                      <b-avatar
                        v-if="selpan.panelID"
                        variant="primary"
                        :text="selpan.name[0]"
                        class="mr-2 fs-12 si-tags-option si-search-dd-option-dp"
                      ></b-avatar>
                      <div class="fw-400 fs-14 font-lato color-mainblue">
                        {{ selpan.name }}
                      </div>
                      <div
                        v-if="!selpan.panelID"
                        class="fs-12 font-lato color-mainblue"
                        style="opacity: 0.6"
                      >
                        <i> &nbsp;&nbsp;(External) </i>
                      </div>
                      <span
                        v-else-if="!vendor && selpan.panelStatus"
                        class="schedint-pic-redtxt ml-2"
                        :class="
                          selpan.panelStatus == 'Available'
                            ? 'activetext'
                            : 'Inactivetext'
                        "
                        >{{ selpan.panelStatus }}</span
                      >
                      <img
                        @click="removePanel(selpan)"
                        src="../../../assets/img/scheduleinterview/tagclose.svg"
                        class="ml-3 pointer"
                        alt=""
                      />
                    </div>
                  </section>
                </section>
              </section>
            </template>

            <template v-if="showhire3xPanelContent">
              <section class="si-allocate-cards h-auto mt-3">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="fw-500 fs-16 font-lato color-black">
                    <img
                      src="../../../assets/img/scheduleinterview/bckarw.svg"
                      alt=""
                      class="mr-1 pointer"
                      @click="showhire3xPanelContent = false"
                    />
                    Allocate Hire3x Panelist:<span class="asterik">*</span>
                  </div>
                  <!-- <div class="font-lato fw-600 fs-14 color-mainblue">
                    <img
                      src="../../../assets/img/scheduleinterview/view.svg"
                      class="mr-2"
                      alt=""
                    />
                    View Internal Panelist
                  </div> -->
                </div>
                <hr style="border-top: 1px dashed #d0d5dd" />
                <section
                  v-if="panelLoading"
                  class="
                    d-flex
                    align-items-center
                    justify-content-center
                    my-3
                    flex-column
                  "
                >
                  <SmallSpinner />
                  <div class="color-7aa1c3">
                    Finding the best Hire3x Panelists...
                  </div>
                </section>
                <section v-else-if="hire3xPanelCount == 0">
                  <div
                    class="
                      d-flex
                      align-items-center
                      fw-600
                      font-mont
                      fs-16
                      color-AD1927
                    "
                  >
                    <img
                      src="../../../assets/img/scheduleinterview/crossmark.svg"
                      alt=""
                      class="mr-2"
                    />
                    No panelists found
                  </div>
                  <div class="mt-2 fw-500 color-717171 fs-15 fw-500 ml-1">
                    No panelists are currently available for this skill
                  </div>
                </section>
                <template v-else>
                  <div
                    class="
                      d-flex
                      align-items-center
                      fw-600
                      font-mont
                      fs-16
                      color-mainblue
                    "
                  >
                    <img
                      src="../../../assets/img/scheduleinterview/tickmark.svg"
                      alt=""
                      class="mr-2"
                    />
                    We found
                    {{
                      hire3xPanelCount > 20
                        ? `${hire3xPanelCount}+`
                        : hire3xPanelCount
                    }}
                    panelists matching skill criteria!
                  </div>
                  <section class="si-h3x-paneldetailsbox mt-2">
                    <div class="fw-500 fs-14 color-mainblue font-mont mb-1">
                      Please follow the steps below:-
                    </div>
                    <ul class="m-0 pl-3">
                      <li class="fw-400 fs-14 color-717171 font-lato">
                        Fill in the remaining details of your session.
                      </li>
                      <li class="fw-400 fs-14 color-717171 font-lato mt-1">
                        Click on "Schedule" to proceed.
                      </li>

                      <li class="fw-400 fs-14 color-717171 font-lato mt-1">
                        Once the ideal panelists are assigned, we will confirm
                        the remaining details.
                      </li>
                    </ul>
                  </section>
                </template>
              </section>
            </template>
            <template v-if="showbotinterviewContent">
              <section class="si-allocate-cards h-auto mt-3">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="fw-500 fs-16 font-lato color-black">
                    <img
                      src="../../../assets/img/scheduleinterview/bckarw.svg"
                      alt=""
                      class="mr-1 pointer"
                      @click="showbotinterviewContent = false"
                    />
                    Allocate AI Bot Interview:<span class="asterik">*</span>
                  </div>
                  <div>
                    <img
                      src="../../../assets/img/scheduleinterview/hire3xai.svg"
                      alt=""
                    />
                  </div>
                </div>
                <hr style="border-top: 1px dashed #d0d5dd" />
                <!-- <section>
                <div
                  class="
                    d-flex
                    align-items-center
                    fw-600
                    font-mont
                    fs-16
                    color-AD1927
                  "
                >
                  <img
                    src="../../../assets/img/scheduleinterview/crossmark.svg"
                    alt=""
                    class="mr-2"
                  />
                  No panelists found
                </div>
                <div class="mt-2 fw-500 color-717171 fs-15 fw-500 ml-1">
                  We have found 20+ panelists matching the skill criteria,
                  Please go ahead and fill the other details and click
                  “schedule”. Once the perfect panelists are assigned we will be
                  confirming the other details
                </div>
              </section> -->
                <div
                  class="
                    d-flex
                    align-items-center
                    fw-600
                    font-mont
                    fs-16
                    color-mainblue
                  "
                >
                  <img
                    src="../../../assets/img/scheduleinterview/tickmark.svg"
                    alt=""
                    class="mr-2"
                  />
                  Bot Interview Selected
                </div>
                <section class="si-h3x-paneldetailsbox mt-2">
                  <div class="fw-500 fs-14 color-mainblue font-mont mb-1">
                    Please follow the steps below:-
                  </div>
                  <ul class="m-0 pl-3">
                    <li class="fw-400 fs-14 color-717171 font-lato">
                      Fill in the remaining details of your session.
                    </li>
                    <li class="fw-400 fs-14 color-717171 font-lato mt-1">
                      Click on "Schedule" to proceed.
                    </li>

                    <li class="fw-400 fs-14 color-717171 font-lato mt-1">
                      Once the ideal panelists are assigned, we will confirm the
                      remaining details.
                    </li>
                  </ul>
                </section>
              </section>
            </template>
          </template>
          <!-- <template v-else>
            <div
              class="
                fw-bold
                d-flex
                justify-content-between
                schedint-main-heads
                mt-2
              "
            >
              <div>Allocate<span class="asterik">*</span></div>
              <span v-if="panelError" class="errortext">
                <img
                  src="../../../assets/img/newkanban/info-circle.svg"
                  class="mr-1"
                  alt=""
                />
                Please add{{
                  !checkVendorExt
                    ? " Internal Panelist"
                    : !checkVendorInt
                    ? " External Panelist"
                    : " External or Internal Panelist"
                }}
              </span>
            </div>
            <div
              v-if="checkVendorInt"
              class="
                d-flex
                align-items-center
                justify-content-between
                mt-3
                mb-3
              "
            >
              <div class="schedint-main-heads">Internal Panelist</div>

              <div class="schedint-blue-txt pointer">
                <template
                  v-if="
                    !vendor &&
                    showCheckAvailability &&
                    ScheduleInterview.panelist &&
                    ScheduleInterview.panelist.length != 0 &&
                    ScheduleInterview.selectedOption == 'Microsoft Teams'
                  "
                >
                  <span class="ml-2" @click="getTeamsAvailability()">
                    (Check Availability)
                  </span>
                  <span>&nbsp;&nbsp;| &nbsp;&nbsp;</span>
                </template>
                <span
                  :style="
                    (!ScheduleInterview.selDate ||
                      !ScheduleInterview.startTime ||
                      !ScheduleInterview.endTime) &&
                    'cursor: not-allowed; opacity: 0.6;'
                  "
                  @click="
                    ScheduleInterview.selDate &&
                    ScheduleInterview.startTime &&
                    ScheduleInterview.endTime
                      ? (showPanel = true)
                      : ''
                  "
                >
                  Add Panelist
                  <img
                    class="ml-2"
                    src="../../../assets/img/newkanban/plus.svg"
                    alt=""
                  />
                </span>
              </div>
            </div>
            <hr
              class="m-0"
              v-if="checkVendorInt && ScheduleInterview.panelist.length != 0"
            />
            <div v-if="checkVendorInt" class="schedint-panelistcards-container">
              <div
                v-for="intPanel in ScheduleInterview.panelist"
                :key="intPanel.panelID"
                class="
                  w-100
                  schedint-panelist-info-container
                  d-flex
                  align-items-center
                  mt-2
                  relativeclass
                "
              >
                <div class="w-5">
                  <div class="text-center roundDarkBlue position-relative">
                    {{ intPanel.name[0].toUpperCase() }}
                  </div>
                </div>
                <div class="w-30 text-center text-truncate mr-1">
                  {{ intPanel.name }}
                </div>
                <div class="w-30 text-center text-truncate">
                  {{ intPanel.email }}
                </div>
                <div class="w-30 text-center">
                  <span
                    v-if="!vendor && intPanel.panelistStatus"
                    class="schedint-pic-redtxt"
                    :class="
                      intPanel.panelistStatus == 'Available'
                        ? 'activetext'
                        : 'Inactivetext'
                    "
                    >{{ intPanel.panelistStatus }}</span
                  >
                </div>
                <div
                  @click="removeIntPanel(intPanel.panelID)"
                  class="w-5 text-center pointer"
                >
                  <img src="../../../assets/img/newkanban/close.svg" alt="" />
                </div>
              </div>
            </div>
            <hr v-if="checkVendorExt && checkVendorInt" class="mt-2" />
            <div v-if="checkVendorExt" class="mt-2">
              <div class="schedint-label-heads">External Panelist</div>
              <div class="position-relative newmodalinputbox mt-1">
                <b-form-input
                  :disabled="
                    !ScheduleInterview.selDate ||
                    !ScheduleInterview.startTime ||
                    !ScheduleInterview.endTime
                  "
                  :class="{ error: !isValidEmail }"
                  v-model.trim="extEmail"
                  placeholder="Enter Email"
                  @keyup="emailChange"
                  @keyup.enter="handleEnter"
                >
                </b-form-input>
              </div>
              <div class="hint-txt-kanban mt-1">
                Press "Enter" to add external panelist
              </div>
            </div>

            <div v-if="checkVendorExt" class="schedint-extpanelist-container">
              <div
                v-for="(panelist, index) in ScheduleInterview.externalPanelist"
                :key="index"
                class="createjob-ip-evaluators d-flex align-items-center mt-2"
              >
                {{ panelist }}
                <img
                  @click="
                    ScheduleInterview.selDate &&
                      ScheduleInterview.startTime &&
                      ScheduleInterview.endTime &&
                      removeExtPanel(index)
                  "
                  src="../../../assets/img/newvendorflow/tagclose.svg"
                  class="ml-2 mt-1 pointer"
                  alt=""
                />
              </div>
            </div>
            <hr class="mt-2" />
          </template> -->
          <div class="mt-3 schedint-schedmeet-container">
            <div class="schedint-main-heads">
              Schedule Meeting
              <span
                v-if="vendor || ScheduleInterview.selectedOption == 'Other'"
                class="asterik"
                >*</span
              >
            </div>
            <div class="d-flex align-items-center w-100 mt-2">
              <div
                @click="
                  checkshowmeeting
                    ? (showmeetingoptions = !showmeetingoptions)
                    : ''
                "
                v-if="$route.name != 'VendorKanban' && checkForDropDown"
                ref="srcdropdown"
                :style="
                  !checkshowmeeting &&
                  'cursor: not-allowed; background-color: #dcdfe1;'
                "
                class="
                  pointer
                  w-30
                  schedint-moi
                  d-flex
                  align-items-center
                  justify-content-between
                  position-relative
                "
              >
                <div>
                  <img
                    v-if="ScheduleInterview.selectedOption == 'Microsoft Teams'"
                    src="../../../assets/img/newkanban/Teams.svg"
                    class="mr-1"
                    alt=""
                  />
                  <img
                    v-else-if="
                      ScheduleInterview.selectedOption == 'Hire3x - VCCL'
                    "
                    width="20"
                    src="../../../assets/img/newkanban/hire3x-newicon.svg"
                    class="mr-1"
                    alt=""
                  />
                  <img
                    v-else-if="
                      ScheduleInterview.selectedOption == 'Google Meet'
                    "
                    src="../../../assets/img/newkanban/gmeet.svg"
                    class="mr-1"
                    alt=""
                  />
                  {{ ScheduleInterview.selectedOption }}
                </div>
                <div>
                  <img src="../../../assets/img/newkanban/downarw.svg" alt="" />
                </div>
                <div
                  ref="src"
                  v-closable="{
                    exclude: ['src', 'srcdropdown'],
                    handler: 'hideMeeting',
                  }"
                  v-if="showmeetingoptions"
                  style="top: 38px; z-index: 2"
                  class="w-100 kanban-more-option-card"
                >
                  <div
                    v-if="checkShowTeams && checkTeamsAccess"
                    :style="
                      ScheduleInterview.selectedOption == 'Microsoft Teams' &&
                      'background-color: #c8d9e5 !important'
                    "
                    @click="assignLink('Microsoft Teams')"
                    class="kanban-more-option-card-input"
                  >
                    <img
                      src="../../../assets/img/newkanban/Teams.svg"
                      class="mr-1"
                      alt=""
                    />
                    Microsoft Teams
                  </div>
                  <div
                    v-if="checkVCCLAccess"
                    :style="
                      ScheduleInterview.selectedOption == 'Hire3x - VCCL' &&
                      'background-color: #c8d9e5 !important'
                    "
                    @click="assignLink('Hire3x - VCCL')"
                    class="kanban-more-option-card-input"
                  >
                    <img
                      width="20"
                      src="../../../assets/img/newkanban/hire3x-newicon.svg"
                      class="mr-1"
                      alt=""
                    />
                    Hire3x - VCCL
                  </div>
                  <div
                    v-if="checkGmeetAccess"
                    :style="
                      ScheduleInterview.selectedOption == 'Google Meet' &&
                      'background-color: #c8d9e5 !important'
                    "
                    @click="assignLink('Google Meet')"
                    class="kanban-more-option-card-input"
                  >
                    <img
                      src="../../../assets/img/newkanban/gmeet.svg"
                      class="mr-1"
                      alt=""
                    />
                    Google Meet
                  </div>
                  <div
                    v-if="vendor || (!vendor && !showhire3xPanelContent)"
                    :style="
                      ScheduleInterview.selectedOption == 'Other' &&
                      'background-color: #c8d9e5 !important'
                    "
                    @click="assignLink('Other')"
                    class="kanban-more-option-card-input"
                  >
                    Other
                  </div>
                </div>
              </div>
              <div
                :class="vendor || !checkForDropDown ? 'w-100' : 'ml-2'"
                class="w-70"
              >
                <div
                  class="position-relative newmodalinputbox"
                  :class="
                    $v.ScheduleInterview.meetingLink.$error && 'mb-2 h-26'
                  "
                >
                  <b-form-input
                    style="padding-right: 25px"
                    :disabled="
                      (vendor &&
                        this.ScheduleInterview.externalPanelist &&
                        this.ScheduleInterview.externalPanelist.length == 0 &&
                        this.ScheduleInterview.panelist &&
                        this.ScheduleInterview.panelist.length == 0) ||
                      (!vendor && disableMetingLink)
                    "
                    type="text"
                    :class="{ error: $v.ScheduleInterview.meetingLink.$error }"
                    v-model.trim="$v.ScheduleInterview.meetingLink.$model"
                    placeholder="Enter meeting link"
                  >
                  </b-form-input>

                  <!-- Meet.jgvwuynf/hgweufw.com -->
                  <img
                    v-if="ScheduleInterview.meetingLink"
                    v-b-tooltip.hover
                    :title="toolTipTitle"
                    @click="copyToClipboard"
                    class="schedint-meetinglink-copyimg pointer"
                    src="../../../assets/img/newkanban/copy.svg"
                    alt=""
                  />
                  <img
                    v-else
                    style="opacity: 0.5; cursor: not-allowed"
                    class="schedint-meetinglink-copyimg"
                    src="../../../assets/img/newkanban/copy.svg"
                    alt=""
                  />
                  <span
                    style="position: absolute"
                    v-if="$v.ScheduleInterview.meetingLink.$error"
                    class="errortext"
                  >
                    Please enter meeting link
                  </span>
                </div>
              </div>
            </div>
            <div class="newmodalinputbox mt-3">
              <div class="schedint-main-heads">Meeting Summary</div>
              <b-form-textarea
                v-model.trim="ScheduleInterview.meetingSummary"
                rows="2"
                placeholder="Enter"
                type="text"
                max-rows="5"
              >
              </b-form-textarea>
            </div>
            <div
              v-if="
                !vendor && ScheduleInterview.selectedOption == 'Microsoft Teams'
              "
              class="
                mt-3
                w-100
                ct-table-switch
                d-flex
                align-items-center
                font-mont
                fs-14
                fw-600
              "
            >
              <b-form-checkbox
                switch
                v-model="ScheduleInterview.allowBot"
              ></b-form-checkbox>
              Add AI Bot to the meeting
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3 mr-3 bluebtn">
          <b-button
            @click="closeScheduleInterview()"
            class="acs-cancelBtn-modal pointer mr-3"
            >Cancel</b-button
          >
          <div class="position-relative">
            <b-button
              class="acs-addBtn-modal w-110"
              @click="checkSchedule()"
              :class="
                LoaderStatus ? 'upload-loader-class defaultCursor' : 'pointer'
              "
              >{{ LoaderStatus ? "" : schedulename.split(" ")[0] }}</b-button
            >
            <div v-if="LoaderStatus" class="upload-loader-pos">
              <Loader />
            </div>
          </div>
        </div>
      </div>

      <TagPanelist
        v-if="showPanel"
        :selectedPanelists="ScheduleInterview.panelist"
        :showTagPanelist="showPanel"
        @hide-modal="showPanel = false"
        @select-panelist="selInternalPanelist"
        :panelList="panelList"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import toast from "../../mixin/toast";
import { required, requiredIf } from "vuelidate/lib/validators";

import Loader from "../../../components/fixedcomponents/Loader.vue";
import SmallSpinner from "@/components/fixedcomponents/SmallSpinner.vue";

import TagPanelist from "../../../components/Kanban/modal/TagPanelist";
import DateField from "../../../components/InputComponents/DateField";
import scheduleMixin from "./scheduleMixin.js";
export default {
  name: "ScheduleInterview",
  props: {
    particularJob: Object,
    candidate: Object,
    toRound: String,
    remarks: String,
    totalNoOfRounds: Number,
    vendorRounds: Number,
    creditsExhausted: Boolean,
    fromAction: Boolean,
  },
  data() {
    return {
      panelLoading: false,
      showLoader: false,
      disableTime: false,
      vendor: false,
      hire3xPanelCount: 0,
      date: null,
      startTime: null,
      endTime: null,
      initialType: null,
      initialLink: null,
      showPanel: false,
      LoaderStatus: false,
      isStartDateValid: false,
      showmeetingoptions: false,
      inValidStartTime: false,
      extEmail: "",
      schedulename: "",
      interviewRound: {},
      initialStartTime: null,
      pageCount: 10,
      currentPage: 1,
      searchQuery: null,
      panelDetails: [],
      pageStart: null,
      pageEnd: null,
      total: null,
      fullData: [],
      fullPanelData: [],
      totalPanel: [],
      ScheduleInterview: {
        selDate: "",
        startTime: "",
        endTime: "",
        meetingLink: "",
        meetingSummary: "",
        externalPanelist: [],
        candidate: {},
        selectedOption: "Microsoft Teams",
        jobID: this.particularJob.jobID,
        customerID: this.particularJob.customerID,
        teams: false,
        panelist: [],
        roundlevel: "0",
        schedulename: "",
        allowBot: false,
      },
      toolTipTitle: "Copy",
      panelList: [],
      panelError: false,
      SpinnerStatus: false,
      showinternalexternalContent: false,
      showhire3xPanelContent: false,
      showbotinterviewContent: false,
      showsearchDropdown: false,
    };
  },
  mixins: [toast, scheduleMixin],
  components: {
    DateField,
    TagPanelist,
    Loader,
    SmallSpinner,
  },
  validations() {
    return {
      ScheduleInterview: {
        selDate: { required },
        startTime: { required },
        endTime: { required },
        meetingLink: {
          required: requiredIf(() => {
            return (
              (this.$route.name == "VendorKanban" ||
                this.ScheduleInterview.selectedOption == "Other") &&
              this.ScheduleInterview.selDate &&
              this.ScheduleInterview.startTime &&
              this.ScheduleInterview.startTime &&
              !this.inValidEndTime &&
              (this.ScheduleInterview.externalPanelist.length != 0 ||
                this.ScheduleInterview.panelist.length != 0)
            );
          }),
        },
      },
    };
  },
  watch: {
    "ScheduleInterview.startTime"(val) {
      if (val) {
        this.chekStartTimeInvalid();
        if (this.initialStartTime != val) {
          this.ScheduleInterview.endTime = this.formattedTime();
        }
      } else this.ScheduleInterview.endTime = "";
    },
    "ScheduleInterview.selectedOption"(val) {
      if (!this.vendor) {
        if (val && this.ScheduleInterview.panelist.length != 0) {
          this.handleSelOptionSwitch();
        }
        if (val) {
          if (val != "Microsoft Teams") this.ScheduleInterview.allowBot = false;
          this.ScheduleInterview.meetingLink = "";
        }
        if (val == this.initialType) {
          this.ScheduleInterview.meetingLink = this.initialLink;
        }
      }
    },
    "ScheduleInterview.panelist"(val) {
      if (val.length != 0) {
        this.panelError = false;
      } else if (!this.checkVendorExt) {
        this.panelError = true;
      }
      if (!this.vendor) {
        if (val.length != 0) {
          this.handleSelOptionSwitch();
        }
      }
    },
    hire3xPanelCount(val) {
      if (this.showhire3xPanelContent && val != 0) this.panelError = false;
      if (this.ScheduleInterview.selectedOption == "Other")
        this.ScheduleInterview.selectedOption = this.getTeamsAvailability()
          ? "Microsoft Teams"
          : this.checkVCCLAccess()
          ? "Hire3x - VCCL"
          : "";
    },
    showhire3xPanelContent(val) {
      if (val) this.ScheduleInterview.meetingLink = "";
      else if (this.initialType == this.ScheduleInterview.selectedOption) {
        this.ScheduleInterview.meetingLink = this.initialLink;
      }
    },
    "ScheduleInterview.externalPanelist"(val) {
      if (val.length != 0) {
        this.panelError = false;
      } else if (!this.checkVendorInt) {
        this.panelError = true;
      }
    },
    "ScheduleInterview.selDate"(val) {
      let currentHour = new Date();
      let startDate = currentHour.getDate();
      let startYear = currentHour.getFullYear();
      let startMonth = currentHour.getMonth() + 1;

      let selectedDate = new Date(this.getDateInFormat());
      let selectDate = selectedDate.getDate();
      let selectMonth = selectedDate.getMonth() + 1;
      let selectYear = selectedDate.getFullYear();

      let currentDate = new Date(startYear, startMonth - 1, startDate);
      let selectedDateTime = new Date(selectYear, selectMonth - 1, selectDate);

      if (
        selectedDateTime < currentDate &&
        this.ScheduleInterview.selDate !== null
      ) {
        this.isStartDateValid = true;
      } else {
        this.isStartDateValid = false;
      }

      const date1 = new Date(currentDate);
      const date2 = new Date(selectedDateTime);
      if (date1.getTime() === date2.getTime()) {
        this.disableTime = true;
      } else {
        this.disableTime = false;
      }
      if (!val) {
        this.ScheduleInterview.startTime = "";
        this.ScheduleInterview.endTime = "";
        this.$forceUpdate();
      }
      if (!this.isStartDateValid && this.ScheduleInterview.startTime) {
        this.chekStartTimeInvalid();
      }
    },
    showbotinterviewContent(val) {
      if (val) {
        this.ScheduleInterview.selectedOption = "Hire3x - VCCL";
        this.panelError = false;
      }
    },
    showsearchDropdown(val) {
      if (val) {
        this.filterPanelData();
      }
    },
    showinternalexternalContent(val) {
      if (!val && this.schedulename != "Reschedule Interview") {
        this.totalPanel = [];
        this.ScheduleInterview.panelist = [];
        this.ScheduleInterview.externalPanelist = [];
      }
    },
    // date(val){
    //   this.date = `${val}T00:00:00.000+00:00`;
    //     // Convert the Date object to the desired format
    //     console.log(this.date)
    // },
    // startTime(val){
    //   this.startTime = `${this.date}T${val}00.000+00:00`;
    //   console.log(this.startTime)
    // }
    extEmail(val) {
      if (val && this.checkVendorInt) {
        this.showsearchDropdown = true;
        this.searchPanelist();
      } else if (!val) {
        this.showsearchDropdown = false;
      }
    },
  },
  computed: {
    ...mapGetters("userVUEX", {
      roleValues: "getRoleValues",
    }),
    ...mapGetters("userVUEX", {
      thirdPartyData: "getThirdPartyData",
    }),
    panelErrorText() {
      let text;
      if (!this.vendor) text = "Panelist";
      else {
        text = !this.checkVendorExt
          ? "Internal Panelist"
          : !this.checkVendorInt
          ? "External Panelist"
          : "External or Internal Panelist";
      }
      return `Please add ${text}`;
    },
    emailAdded() {
      if (this.checkVendorExt) {
        let emails = this.ScheduleInterview.panelist.map((obj) => obj.email);
        emails = [...emails, ...this.ScheduleInterview.externalPanelist];
        return emails.includes(this.extEmail);
      }
      return false;
    },
    showBot() {
      return true;
      // if (!this.checkLicense) return true;
      // else return this.staticLicenseKey.includes(this.licenseKey);
    },
    searchPlaceholder() {
      let text = !this.checkVendorExt
        ? "Search"
        : !this.checkVendorInt
        ? "Enter"
        : "Enter/Search";
      return text + " email ID";
    },
    emailError() {
      if (this.checkVendorExt)
        return !this.isValidEmail && this.panelDetails.length == 0;
      else return this.extEmail && this.panelDetails.length == 0;
    },
    panelDisabled() {
      return (
        !this.ScheduleInterview.selDate ||
        !this.ScheduleInterview.startTime ||
        !this.ScheduleInterview.endTime
      );
    },
    checkVendorExt() {
      if (this.vendor) {
        return (
          this.getvendor.panelist == "external" ||
          this.getvendor.panelist == "both"
        );
      } else {
        if (
          this.particularJob.recruiterConfig.common &&
          this.particularJob.recruiterConfig.panelist
        ) {
          return (
            this.particularJob.recruiterConfig.panelist == "external" ||
            this.particularJob.recruiterConfig.panelist == "both"
          );
        } else {
          let currentRec = this.particularJob.assignedTo.find(
            (obj) => obj.userID == this.roleValues.userID
          );
          if (!currentRec) {
            return true;
          } else {
            return (
              !currentRec.panelist ||
              currentRec.panelist == "external" ||
              currentRec.panelist == "both"
            );
          }
        }
      }
    },
    checkVendorInt() {
      if (this.vendor) {
        return (
          (this.getvendor.panelist == "internal" ||
            this.getvendor.panelist == "both") &&
          (this.particularJob.assignedPanelist.length != 0 ||
            this.particularJob.showAllPanelist)
        );
      } else {
        if (
          this.particularJob.recruiterConfig.common &&
          this.particularJob.recruiterConfig.panelist
        ) {
          return (
            this.particularJob.recruiterConfig.panelist == "internal" ||
            (this.particularJob.recruiterConfig.panelist == "both" &&
              (this.particularJob.assignedPanelist.length != 0 ||
                this.particularJob.showAllPanelist))
          );
        } else {
          let currentRec = this.particularJob.assignedTo.find(
            (obj) => obj.userID == this.roleValues.userID
          );
          if (!currentRec) {
            if (
              !this.particularJob.showAllPanelist &&
              this.particularJob.assignedPanelist.length == 0
            )
              return false;
            else return true;
          } else {
            return (
              !currentRec.panelist ||
              currentRec.panelist == "internal" ||
              currentRec.panelist == "both"
            );
          }
        }
        // return (
        //   (this.particularJob.recruiterConfig.panelist == "internal" ||
        //     this.particularJob.recruiterConfig.panelist == "both") &&
        //   (this.particularJob.assignedPanelist.length != 0 ||
        //     this.particularJob.showAllPanelist)
        // );
      }
    },
    checkExternalMails() {
      for (let i in this.ScheduleInterview.externalPanelist) {
        let mail = this.ScheduleInterview.externalPanelist[i].split("@")[1];
        if (this.companyMail(mail)) {
          return true;
        }
      }
      return false;
    },
    newDataeVAS() {
      const [day, month, year] = this.ScheduleInterview.selDate.split("-");
      // Extract time components
      const [hours, minutes] = this.ScheduleInterview.startTime.split(":");

      // Construct the full date-time string in UTC
      const date = new Date(year, month - 1, day, hours, minutes, 0, 0); // Note: Months are 0-based in JavaScript Date

      // Convert to the desired format
      let result = date.toISOString();
      return result;
    },
    newDataeEnd() {
      const [day, month, year] = this.ScheduleInterview.selDate.split("-");
      // Extract time components
      const [hours, minutes] = this.ScheduleInterview.endTime.split(":");

      // Construct the full date-time string in UTC
      const date = new Date(year, month - 1, day, hours, minutes, 0, 0); // Note: Months are 0-based in JavaScript Date
      // Convert to the desired format
      let result = date.toISOString();
      return result;
    },
    checkshowmeeting() {
      if (!this.vendor && this.showbotinterviewContent) return false;
      else if (
        !this.vendor &&
        this.showhire3xPanelContent &&
        this.hire3xPanelCount != 0
      )
        return true;
      return (
        this.ScheduleInterview.selDate &&
        this.ScheduleInterview.startTime &&
        this.ScheduleInterview.endTime &&
        (this.ScheduleInterview.externalPanelist.length != 0 ||
          this.ScheduleInterview.panelist.length != 0)
      );
    },
    inValidEndTime() {
      if (this.ScheduleInterview.startTime && this.ScheduleInterview.endTime) {
        const now = new Date();
        const sel = new Date(this.getDateInFormat());
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");
        let currentTime = `${hours}:${minutes}`;
        sel.setHours(0, 0, 0, 0);
        now.setHours(0, 0, 0, 0);
        if (
          now.getTime() === sel.getTime() &&
          this.ScheduleInterview.endTime <= currentTime
        ) {
          return true;
        } else if (
          this.ScheduleInterview.endTime > this.ScheduleInterview.startTime
        ) {
          return false;
        } else {
          return true;
        }
      }
      return false;
    },
    getvendor() {
      return this.particularJob.vendor.find(
        (obj) => obj.vendorID == this.$route.params.vendorID
      );
    },
    isValidEmail() {
      // Regular expression for basic email validation
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
      if (this.extEmail.length != 0) {
        if (this.ScheduleInterview.externalPanelist.includes(this.extEmail)) {
          return false;
        }
        return emailPattern.test(this.extEmail);
      }
      return true;
    },
    checkShowTeams() {
      if (!this.showCheckAvailability) {
        return (
          this.roleValues.email.endsWith("@hire3x.com") ||
          this.roleValues.email.endsWith("@simplify3x.com") ||
          this.roleValues.email.endsWith("@norwintechnologies.com")
        );
      } else {
        return true;
      }
    },
    disableMetingLink() {
      if (!this.vendor) {
        if (this.checkshowmeeting) {
          return this.ScheduleInterview.selectedOption != "Other";
        } else {
          return true;
        }
      }
      return false;
    },
    checkTeamsAccess() {
      let val = this.thirdPartyData.data.find(
        (obj) => obj.thirdPartyID === "msteams"
      );
      if (!val) {
        return false;
      }
      return val.enabled;
    },
    checkVCCLAccess() {
      let val = this.thirdPartyData.data.find(
        (obj) => obj.thirdPartyID === "hire3xvccl"
      );
      if (!val) {
        return false;
      }
      return val.enabled;
    },
    checkGmeetAccess() {
      if (this.showhire3xPanelContent && this.hire3xPanelCount != 0)
        return false;
      let val = this.thirdPartyData.data.find(
        (obj) => obj.thirdPartyID === "gmeet"
      );
      if (!val) {
        return false;
      }
      return val.enabled;
    },
    checkForDropDown() {
      return (
        (this.checkShowTeams && this.checkTeamsAccess) || this.checkVCCLAccess
      );
    },
    checkVendorRounds() {
      if (
        this.totalNoOfRounds - 5 > this.vendorRounds ||
        parseInt(this.toRound + 1) < this.vendorRounds
      ) {
        return false;
      }
      return true;
    },
    disableHire3xPanel() {
      if (this.interviewRequestID) return false;
      else return this.creditsExhausted;
    },
    scheduleText() {
      return this.disableHire3xPanel
        ? "Insufficient Credits!<br/>Add credits to schedule with the certified Hire3x panelists"
        : "Schedule with the certified Hire3x panelists";
    },
  },

  created() {
    this.type = "schedule";
    this.vendor = this.$route.name == "VendorKanban" ? true : false;
    if (this.vendor) {
      if (
        this.getvendor.panelist == "internal" ||
        this.getvendor.panelist == "both"
      ) {
        if (!this.particularJob.showAllPanelist) {
          this.panelList = this.particularJob.assignedPanelist;
        }
      }
    } else {
      if (this.checkVendorInt && !this.particularJob.showAllPanelist) {
        this.panelList = this.particularJob.assignedPanelist;
      }
      // if (!this.checkVCCLAccess || !this.showBot)
      //   this.showinternalexternalContent = true;
    }
    this.ScheduleInterview.selectedOption =
      this.checkShowTeams && this.checkTeamsAccess
        ? "Microsoft Teams"
        : this.checkVCCLAccess
        ? "Hire3x - VCCL"
        : "Other";
    this.setCandidateData();
    if (this.checkVendorInt) {
      if (this.panelList.length == 0) this.getPanelPagination();
      else {
        let panelvalues = JSON.parse(JSON.stringify(this.panelList));
        panelvalues.map((obj) => {
          obj.name = obj.username;
          obj.active = obj.isActive;
          delete obj.isActive;
          delete obj.username;
          return obj;
        });
        const uniqueset = new Set();
        this.panelDetails = panelvalues.filter((item) => {
          const value = item.panelID;
          return uniqueset.has(value) ? false : uniqueset.add(value);
        });
        this.getActivePanel();
      }
    }
  },
};
</script>

<style scoped>
.newInt-previewInputField.form-control {
  font-weight: 500;
  color: #333;
}
.errortext {
  color: #eb0002;
  font-size: 11px;
  font-weight: 500;
}

.upload-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 110px;
}

.upload-loader-class-new {
  opacity: 0.5;
}

.upload-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 11px;
}

.h-26 {
  height: 26px;
}

.common-blue-card-head {
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #3a3c40;
}

.common-blue-card-subhead {
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: 13px;
  color: #3a3c40;
}

.alreadyintw-main-heads {
  font-family: var(--montserrat);
  font-weight: 500;
  font-size: 14px;
  color: #344054;
}
.si-allocate-cards {
  padding: 16px;
  height: 160px;
  flex: 1;
  background: #f6f9fb;
  border: 1px solid rgba(32, 99, 155, 0.12);
  border-radius: 8px;
}
.si-search-dd {
  padding: 6px 0px;
  position: absolute;
  max-height: 232px;
  min-height: auto;
  background: #f9f9f9;
  border: 1px solid rgba(41, 136, 230, 0.22);
  border-radius: 12px;
  z-index: 2;
  overflow: auto;
}
.si-search-dd-option {
  height: 49px;
  padding: 6px 14px;
}
.si-search-dd-option:hover {
  background: #c8d9e5;
}
.si-search-dd-option-dp {
  width: 36px;
  height: 36px;
  border: 1.5px solid #ffffff;
  border-radius: 150px;
}
.si-search-dd-option .badge-primary,
.si-panelist-tags .badge-primary {
  background-color: #20639b;
}
.si-panelist-tags {
  padding: 5px 10px;
  background: #e1eef7;
  border-radius: 5px;
}
.si-tags-option {
  width: 24px;
  height: 24px;
}
.si-h3x-paneldetailsbox {
  padding: 12px;
  background: rgba(32, 99, 155, 0.08);
  border-radius: 4px;
}
</style>
